<template>
  <div>
    <!-- breadcrumb -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信好友</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- search -->
    <el-form :inline="true" :model="queryForm" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryForm.friendWxid" placeholder="friendId" clearable style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="queryForm.nickName" placeholder="名称" clearable style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="queryForm.remark" placeholder="备注" clearable style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="queryForm.robotWxid" placeholder="机器人" clearable style="width: 160px;">
          <el-option
            v-for="item in robotList"
            :key="item.robotWxid"
            :label="item.robotWxid"
            :value="item.robotWxid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh-left" @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!--list-->
    <el-table
      size="small"
      :data="tableData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="loading"
      style="width: 100%;">
      <el-table-column
        prop="isGroup"
        label="类型"
        width="60"
        align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.isGroup ? '群' : '好友' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="friendWxid"
        label="friendId"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="headUrl"
        label="头像"
        width="60"
        align="center">
        <template slot-scope="scope">
          <el-avatar v-if="scope.row.headUrl" :size="30" :src="scope.row.headUrl"></el-avatar>
          <i v-else class="el-icon-user" style="font-size: 20px; color: #909399;"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickName"
        label="名称"
        min-width="180"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="80"
        align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.remark" class="el-icon-edit-outline" style="color: #409EFF; cursor: pointer;" :title="scope.row.remark"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="robotWxid"
        label="机器人"
        width="180"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="缓存时间"
        width="160">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.updateTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- page -->
    <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>
  </div>
</template>

<script>
import { friendPage } from '../../api/friend'
import { robotPage } from '../../api/robot'
import Pagination from '../../components/Pagination'
import { loadToken } from '../../utils/util'

export default {
  name: 'Friend',
  data() {
    return {
      loading: false,
      tableData: [],
      robotList: [],
      queryForm: {
        current: 1,
        size: 10,
        friendWxid: undefined,
        nickName: undefined,
        remark: undefined,
        robotWxid: undefined,
        isGroup: false,
        token: loadToken()
      },
      // page param
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  components: {
    Pagination
  },
  created() {
    this.loadRobotList()
    this.getPageData()
  },
  methods: {
    // 加载机器人列表
    loadRobotList() {
      robotPage({ current: 1, size: 1000, token: loadToken() })
        .then(res => {
          this.robotList = res.data.records || []
        })
        .catch(err => {
          console.error('加载机器人列表失败:', err)
        })
    },
    // 加载分页数据
    getPageData(parameter) {
      this.loading = true
      if (!parameter) {
        parameter = this.queryForm
      }
      friendPage(parameter)
        .then(res => {
          this.loading = false
          this.tableData = res.data.records
          this.pageParam.currentPage = res.data.current
          this.pageParam.pageSize = res.data.size
          this.pageParam.total = res.data.total
        })
        .catch(err => {
          this.loading = false
          console.error('获取数据失败:', err)
          this.$message({
            type: 'error',
            message: '获取数据失败，请检查网络连接或稍后重试'
          })
        })
    },
    // 分页回调
    callback_getPageData(parm) {
      this.queryForm.current = parm.currentPage
      this.queryForm.size = parm.pageSize
      this.getPageData()
    },
    // 搜索
    onSearch() {
      this.queryForm.current = 1
      this.getPageData()
    },
    // 重置
    onReset() {
      this.queryForm.friendWxid = undefined
      this.queryForm.nickName = undefined
      this.queryForm.remark = undefined
      this.queryForm.robotWxid = undefined
    },
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      return dateTime.replace('T', ' ')
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.user-search .el-input--small {
  width: 180px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/friend/friend.vue